<div *transloco="let t; read: 'subscription-details'" class="h-full w-full">
    <div class="p-6">
        @if (loading) {
        <div class="flex justify-center items-center min-h-64">
            <vui-progress-spinner [mode]="'indeterminate'"></vui-progress-spinner>
        </div>
        } @else if (!hasSubscriptionDetails) {
        <div
            class="flex flex-col justify-center items-center min-h-64 bg-white p-10 rounded-lg shadow-md border border-gray-100"
        >
            <mat-icon color="warn" class="mb-4" style="font-size: 48px; width: 48px; height: 48px">
                vpn_key_off
            </mat-icon>
            <h2 class="text-2xl text-center font-bold text-gray-900 mb-2">{{ t("no_subscription_title") }}</h2>
            <p class="text-base text-gray-600 mb-8 text-center">{{ t("no_subscription_description") }}</p>

            <v2-button-wrapper
                color="primary"
                text="{{ t('Subscribe Plan') }}"
                variant="raised"
                icon="check"
                (click)="createSubscription()"
            ></v2-button-wrapper>
        </div>
        } @else {
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            <div class="edition-card flex flex-col justify-center">
                <mat-icon color="primary" [svgIcon]="isSubscriptionActive ? 'star' : 'triangle'"></mat-icon>
                <h3 class="title-medium">
                    {{ t(editionName) || t("No Plan Name") }}
                </h3>

                @if (isSubscriptionActive) {
                <p class="next-billing">{{ t("next_billing_on") }} {{ due[0]?.dueDate | date : "dd/MM/yyyy" }}</p>

                <div class="flex flex-col md:flex-row items-center gap-4">
                    <v2-button-wrapper
                        text="{{ t('Change Plan') }}"
                        variant="stroked"
                        color="primary"
                        [bold]="true"
                        size="small-button"
                        (click)="changeSubscription()"
                    ></v2-button-wrapper>

                    <v2-button-wrapper
                        text="{{ t('Cancel Plan') }}"
                        color="warn"
                        size="small-button"
                        (click)="cancelSubscription()"
                    ></v2-button-wrapper>
                </div>
                } @else if (isTrialing) {
                <div class="mt-4">
                    <p class="text-base text-red-600 font-semibold mb-6">
                        {{ t("trial_ends_on") }} {{ startDate | date : "dd/MM/yyyy" }}
                    </p>

                    <v2-button-wrapper
                        color="primary"
                        text="{{ t('Subscribe Plan') }}"
                        variant="raised"
                        icon="check"
                        (click)="createSubscription()"
                    ></v2-button-wrapper>
                </div>
                } @else if (isSubscriptionInactive) {
                <div class="mt-4">
                    <p class="text-base text-gray-600 font-semibold mb-6">
                        {{ t("plan_status", { status: status.code }) }}
                    </p>
                    <v2-button-wrapper
                        color="primary"
                        text="{{ t('Reactivate Plan') }}"
                        variant="raised"
                        icon="check"
                        (click)="createSubscription()"
                    ></v2-button-wrapper>
                </div>
                }
            </div>

            <div class="payment-method-card flex flex-col items-start gap-4">
                <div class="section-title flex items-center gap-2">
                    <mat-icon [svgIcon]="'card-atm'"></mat-icon>
                    <span> {{ t("Payment Method") }}</span>
                </div>
                @if (customer?.creditCard) {
                <div class="inner-card flex-grow flex items-center w-full gap-2">
                    <div class="flex items-center gap-2">
                        <mat-icon [svgIcon]="'master-card'"></mat-icon>
                        <div class="flex flex-col gap-2">
                            <span>
                                {{ customer.creditCard.digits }}
                            </span>
                            <span>
                                {{ t("expires_on") }} {{ customer.creditCard.expirationMonth }}/
                                {{ customer.creditCard.expirationYear }}
                            </span>
                            <span>{{ customer.creditCard.ownerName }}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <v2-button-wrapper
                        text="{{ t('Edit Method') }}"
                        color="primary"
                        variant="stroked"
                        (click)="editPaymentMethod()"
                    ></v2-button-wrapper>
                </div>
                } @else {
                <div class="inner-card flex-grow flex items-center w-full gap-2">
                    <p class="text-base text-gray-600 mb-6">
                        {{ t("no_payment_method_registered") }}
                    </p>
                </div>

                <div>
                    <v2-button-wrapper
                        text="{{ t('Register Payment Method') }}"
                        color="primary"
                        variant="stroked"
                        (click)="registerPaymentMethod()"
                    ></v2-button-wrapper>
                </div>

                }
            </div>
        </div>

        <div class="flex flex-col gap-4">
            <h2 class="title-medium">{{ t("Payment History") }}</h2>

            <div class="flex flex-col gap-2">
                @for (item of future; track $index) {
                <!-- <div class="payment-history-row flex flex-col md:flex-row justify-between md:items-center">
                    <span class="title-medium"
                        >{{ t(editionName) }} - <span class="price"> R$ {{ item.price }} </span>
                    </span>

                    <div class="flex items-center justify-between gap-4">
                        <div class="flex flex-col md:flex-row md:items-center md:gap-4">
                            <span class="due-date" [class.text-green-600]="item.status === 'paid'">
                                {{ item.status === "paid" ? t("Paid") : t("Pending") }}
                            </span>

                            <span class="due-date">
                                {{ item.dueDate | date : "dd/MM/yyyy" }}
                            </span>
                        </div>

                        <button mat-icon-button>
                            <mat-icon [svgIcon]="'cloud-download'"></mat-icon>
                        </button>
                    </div>
                </div> -->
                } @if (!due?.length && !future?.length && !loading) {
                <div class="text-center text-gray-500 p-8">
                    {{ t("no_billing_history") }}
                </div>
                }
            </div>
        </div>
        }
    </div>
</div>
